'use client'

import { useEffect } from 'react'

/**
 * The slow flicker across the stack: every so often one cell lights up in the
 * accent and fades back.
 *
 * The design runs one timer for the whole page rather than an animation per
 * cell, and picks its target at random — which is what keeps it from reading
 * as a loop. Anything marked `data-glow` takes part, so the grid on the home
 * and about pages and the cloud on the stack page share this one component.
 */
export function StackGlow() {
    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return
        }

        const timers = new Set<number>()

        const tick = window.setInterval(() => {
            const cells = document.querySelectorAll<HTMLElement>('[data-glow]:not([data-glow-on])')

            if (cells.length === 0) {
                return
            }

            const cell = cells[Math.floor(Math.random() * cells.length)]
            const wash = cell.querySelector<HTMLElement>('[data-glow-wash]')

            cell.dataset.glowOn = ''
            cell.style.color = 'var(--color-accent)'

            if (wash !== null) {
                wash.style.opacity = '0.08'
            }

            timers.add(
                window.setTimeout(() => {
                    delete cell.dataset.glowOn
                    cell.style.color = ''

                    if (wash !== null) {
                        wash.style.opacity = '0'
                    }
                }, 1500),
            )
        }, 900)

        return () => {
            window.clearInterval(tick)
            timers.forEach((timer) => window.clearTimeout(timer))
        }
    }, [])

    return null
}
